import * as React from 'react';
import { useCallback, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import * as _ from 'lodash';

import { ticketUnaddressedSelector } from '@/redux/app/selectors/ticket';
import { setUnaddressed } from '@/redux/app/actions/ticket';
import { NavigationPaneRouteParamsContext } from '@/lib/navigation';

export interface TicketUnaddressedToggleProps {
  ticket: string;
}

export const TicketUnaddressedToggle = ({ ticket }: TicketUnaddressedToggleProps) => {
  const { subdomain } = useContext(NavigationPaneRouteParamsContext);
  const unaddressed = useSelector(_.partial(ticketUnaddressedSelector, ticket));
  const dispatch = useDispatch();
  const handleClick = useCallback(() => {
    dispatch(setUnaddressed(subdomain, ticket, !unaddressed));
  }, [unaddressed, subdomain, dispatch]);

  return (
    <div
      className={classNames('unaddressed', { on: unaddressed })}
      tabIndex={0}
      role="button"
      aria-label="toggle addressed"
      onClick={handleClick}
      onKeyPress={handleClick}
      data-ticket-uuid={ticket}
    />
  );
};
